import { useContext } from 'react';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';
import Icon from '@ant-design/icons';

import { ContextWrapper } from 'contexts/wrapper.context';
import { getAppStoreAccess } from 'utils/permissions/permissions-apply';
import { UNAUTHORIZED_ERROR_MSG } from 'constants/common';

import BRButton from 'components/BRButton/BRButton';

import './SectionCard.less';

const SectionCard = ({
  classname,
  title,
  subtitle,
  iconClassName,
  icon,
  subIcon,
  onButtonClicked = () => {},
  showConnectButton = true,
  intl,
  isBtnDisabled = false,
  name,
  btnTitle = false,
  hasMangePlugin
}) => {
  const { businessInfo } = useContext(ContextWrapper);

  const { DIM_INSTALL_BUTTON } = getAppStoreAccess(
    businessInfo?.userSllrPermissions
  );

  return (
    <div
      className={classnames('br-chats-section-card', {
        [classname]: classname
      })}
      key={name}
    >
      <div className="br-chats-section-card__content">
        <span
          className={classnames('br-chats-section-card__icon', {
            [iconClassName]: iconClassName
          })}
        >
          <Icon component={icon} />
          {subIcon && <Icon component={subIcon} />}
        </span>
        <div className="br-chats-section-card__right-content">
          <div className="br-chats-section-card__right-content__text">
            <div className="heading">
              {title}
              {btnTitle && !hasMangePlugin && (
                <span className="br-side-bar__extra-label">
                  {intl.formatMessage({
                    id: 'common.added'
                  })}
                </span>
              )}
            </div>
            <span className="br-chats-section-card__right-content__text__subtitle">
              {subtitle}
            </span>
          </div>
          {showConnectButton && (
            <BRButton
              label={btnTitle || intl.formatMessage({ id: 'common.connect' })}
              className={classnames('button-md', {
                'br-chats-section-card__btn-green': btnTitle && !hasMangePlugin
              })}
              onClick={onButtonClicked}
              disabled={isBtnDisabled || DIM_INSTALL_BUTTON}
              loading={isBtnDisabled}
              tooltipTitle={DIM_INSTALL_BUTTON && UNAUTHORIZED_ERROR_MSG}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default injectIntl(SectionCard);
